import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, Modal } from "react-native"
import { Button, Text, View } from '../../../Components/Themed';
import { SocialComponentApi, SocialOrderHelpers } from '../../api';
import type { AthleteProps, EventProps, LeagueProps, MatchProps, OrderProps, TeamProps, TournamentProps } from '../../../types';
import { useColors } from '../../../constants/useColors';
import SocialOrderCard from '../../SocialOrderCard';

type ActionSelectProps = {
    visible:boolean,
    onClose:() => void,
    onTagOrder:(order:OrderProps) => void,
    insets?:{ top:number, left:number, right:number, bottom:number }
}

const sections = ['toggle','orders']
const ActionSelector = ({ visible, insets, onClose, onTagOrder }:ActionSelectProps) => {
    const Colors = useColors();
    const [ tagged_action, setTaggedAction ] = useState<{
        tagged_orders:string[]
    }>({
        tagged_orders:[]
    });
    const { tagged_orders } = tagged_action;
    const [ action_state, setActionState ] = useState<{
        loading:boolean,
        orders:OrderProps[],
        events:EventProps[],
        tournaments:TournamentProps[],
        matches:MatchProps[],
        leagues:LeagueProps[],
        teams:TeamProps[],
        athletes:AthleteProps[]
    }>({
        loading:false,
        orders:[],
        events: [],
        tournaments:[],
        leagues:[],
        teams:[],
        matches:[],
        athletes:[]
    });
    const { loading, orders, events, athletes, leagues, tournaments, matches, teams } = action_state;

    useEffect(() => {
        if(!visible){ return setTaggedAction({ ...tagged_action, tagged_orders: [] })}
        getMyAction()
    },[visible]);

    const getMyAction = async() => {
        setActionState({ ...action_state, loading:true });
        const ords = await SocialComponentApi.getMyAction()
        const { event_ids, tournament_ids, match_ids, athlete_ids, team_ids } = SocialOrderHelpers.getIdsFromOrders(ords);
        let l = await SocialComponentApi.getLeagues();
        let e = await SocialComponentApi.getEventsByEventIds(event_ids);
        let t = await SocialComponentApi.getTournamentsByTournamentIds(tournament_ids);
        let m = await SocialComponentApi.getMatchesByMatchIds(match_ids);
        let a = await SocialComponentApi.getAthletesByIds(athlete_ids);
        let tm = await SocialComponentApi.getTeamsByIds(team_ids);
        setActionState({
            ...action_state,
            loading:false,
            leagues: l,
            teams:tm,
            orders:ords,
            matches: m,
            tournaments: t,
            events: e,
            athletes: a
        });
    }

    const renderOrders = (data: { item:OrderProps, index:number }) => {
        const { time, title, league } = SocialOrderHelpers.getContestDetails(data.item, events, tournaments, matches, athletes, teams, leagues);
        const tagged = tagged_orders.includes(data.item.order_id) ? true : false
        return (
            <View transparent style={{ margin:5, borderWidth:tagged?2:0, borderColor:Colors.text.success}}>
                <SocialOrderCard
                    order={data.item}
                    
                    league={league}
                    onTagOrder={(order) => {
                        if(tagged){
                            setTaggedAction({
                                ...tagged_action,
                                tagged_orders: tagged_orders.filter(o => o != order.order_id)
                            });
                        } else {
                            setTaggedAction({
                                ...tagged_action,
                                tagged_orders: tagged_orders.filter(o => o != order.order_id).concat(order.order_id)
                            });
                        }
                        
                        onTagOrder(order)
                    }}
                    contest_time={time}
                    contest_title={title}
                />
            </View>
            
        )
    }

    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'toggle':
                return <></>
            case 'orders':
                return (
                    <View transparent style={{ padding:10 }}>
                        <FlatList
                            key={`action_orders`}
                            keyExtractor={(item) => item.order_id.toString()}
                            renderItem={renderOrders}
                            data={orders}
                        />
                    </View>
                    
                )
            default: return <></>
        }
    }

    return (
        <Modal
            visible={visible}
            style={{ flex:1 }}
            animationType='slide'
            transparent
        >
            <View type='blur' style={{ flex:1, paddingTop:insets?.top, paddingBottom:insets?.bottom }}>
                <View float style={{ flex:1, margin:20 }}>
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                        <View transparent style={{ flex:1 }}>
                            <Text theme='h1'>Your Current Action</Text>
                            <Text style={{ marginTop:3 }} theme='description'>Select the order or other action you would like to tag!</Text>
                        </View>
                        <Button
                            style={{ height:30, width:30, borderRadius:100, justifyContent:'center', alignItems:'center', padding:0 }}
                            title='X'
                            float
                            type='close'
                            onPress={() => onClose()}
                        />
                    </View>
                    {loading ?
                    <ActivityIndicator style={{ padding:20, alignSelf:'center' }} size='large' color={Colors.text.h1}/>
                    :<></>}
                    <View transparent style={{ flex:1 }}>
                        <FlatList
                            data={sections}
                            key={'action_selector_sections'}
                            keyExtractor={item => item}
                            renderItem={renderSections}
                        />
                    </View>
                </View>
            </View>
        </Modal>
    )
}

export default ActionSelector